import { FIELDS } from './constants';

const defaultFields = [
  {
    key: 'id',
    field: FIELDS.ID,
    title: 'Id',
    label: 'id',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    key: 'code',
    field: FIELDS.CODE,
    title: 'Code',
    label: 'code',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'description',
    field: FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'createdByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: 'Created By User Id',
    label: 'createdByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'createdByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By User Full Name',
    label: 'createdByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'modifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: 'Modified By User Id',
    label: 'modifiedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'modifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By User Full Name',
    label: 'modifiedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateCreated',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'dateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateModified',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'dateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'active',
    sortable: true,
    hidden: false,
    width: 150,
  },

]

export default defaultFields;
